var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterGreenOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.773 11.5988C8.791 11.6148 8.808 11.6298 8.825 11.6478C9.904 12.7538 10.499 14.2188 10.499 15.7738V19.7578L12.735 18.5398C12.911 18.4438 13.02 18.2558 13.02 18.0488V15.7618C13.02 14.2128 13.609 12.7528 14.678 11.6528L19.515 6.50776C19.828 6.17476 20 5.73776 20 5.27676V4.34076C20 3.87676 19.634 3.49976 19.186 3.49976H4.315C3.866 3.49976 3.5 3.87676 3.5 4.34076V5.27676C3.5 5.73776 3.672 6.17476 3.985 6.50676L8.773 11.5988ZM10.146 21.5008C9.944 21.5008 9.744 21.4468 9.562 21.3388C9.21 21.1288 8.999 20.7578 8.999 20.3458V15.7738C8.999 14.6388 8.576 13.5698 7.805 12.7508C7.782 12.7318 7.759 12.7108 7.739 12.6888L2.893 7.53576C2.317 6.92376 2 6.12076 2 5.27676V4.34076C2 3.04976 3.039 1.99976 4.315 1.99976H19.186C20.461 1.99976 21.5 3.04976 21.5 4.34076V5.27676C21.5 6.11976 21.183 6.92176 20.609 7.53476L15.762 12.6888C14.959 13.5168 14.52 14.6058 14.52 15.7618V18.0488C14.52 18.8048 14.111 19.4968 13.453 19.8568L10.692 21.3608C10.52 21.4538 10.333 21.5008 10.146 21.5008Z",
    fill: "#22BBB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGreenOutline);
export default __webpack_public_path__ + "static/media/filter-green-outline.f6dc836f8a9f7ae3f50fee7d42da8507.svg";
export { ForwardRef as ReactComponent };